export const TRUCK_RENTAL = 2;
export const TRAILER_LEASE = 5;
